import {
  ClientCookieSetting,
  ExperimentValueOverrideTable,
  FeatureFlag,
  FeatureFlagSubset,
  SubscriptionTier,
  UserLanguage,
  ValidSystemTheme
} from '.'

export interface NextContextSSRData {
  nextContextInitialized: boolean
  userId: string | null
  iosAnalyticsId: string | null
  featureFlags: FeatureFlagSubset
  valueOverrides: ExperimentValueOverrideTable
  experimentGroups: Record<string, string>
  productionFeatureFlags: FeatureFlag[]
  avatarUpdatedAt: string | null
  screenname: string | null
  userLanguage: UserLanguage | null
  dontShowCommunityGuidelinesAgain: boolean | null
  numUnreadNotifications: number
  email: string | null
  emailVerifiedAt: string | null
  inApp: boolean
  iosAppFeatures: string[] | null
  nativeTheme: ValidSystemTheme | null
  analyticsOptSetting: ClientCookieSetting
  galleryIsDegraded: boolean
  subscriptionTier: SubscriptionTier | null
  trialActive: boolean
}

export interface NextContextContents extends NextContextSSRData {
  logIn: (
    newUserId: string,
    newScreenname: string,
    newEmail: string,
    newEmailVerifiedAt: string | null,
    avatarUpdatedAt: Date | null,
    dismissGuidelines: boolean | null
  ) => void
  logOut: () => void
  updateAvatarUrl: (date?: Date) => void
  setScreenname: (screenname?: string) => void
  setDontShowCommunityGuidelinesAgain: (dismissGuidelines?: boolean) => void
  clearNotifications: () => void
  setAnalyticsOptState: (setting: ClientCookieSetting) => void
  setUserLanguage: (newLanguage: UserLanguage | undefined) => void
}

export interface NextContextProps {
  _nextContext: NextContextSSRData
}
